// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"52ba9ea1","648":"2906203c","787":"4f8524e6"}[chunkId] + ".chunk.js";
};